var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.415 4.415a.625.625 0 0 1 .884 0l4.286 4.286a.625.625 0 1 1-.884.884l-4.286-4.286a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.272 1.558a.625.625 0 0 1 .884 0l4.286 4.286a.625.625 0 0 1 0 .884L8.156 21.013a.625.625 0 0 1-.29.165l-5.714 1.428a.625.625 0 0 1-.758-.758l1.428-5.714a.625.625 0 0 1 .165-.29L17.272 1.558ZM3.992 16.605 2.86 21.141l4.536-1.134L21.116 6.286l-3.402-3.402L3.993 16.605Z",
    fill: "currentColor"
  })));
};
export default SvgEdit;